import { Avatar } from "primereact/avatar";
import { Checkbox } from "primereact/checkbox";
import { useCallback, useEffect, useState } from "react";
import {
  Control,
  Controller,
  UseFormGetValues,
  UseFormSetValue,
} from "react-hook-form";
import { useAppSelector } from "store/store";
import { User } from "interfaces";
import { InputSearchUsersShareModal } from "pages/account/pages/projectsPage/components/card/components/actions";
import elementNotFoundImage from "../../assets/images/element_not_found.svg";
import { labelUserNotFound } from "_constants";

export const FormShareProject = ({
  control,
  usersList,
  getValues,
  setValue,
}: {
  control: Control<{ projectId: string; userIdsList: string[] }, any>;
  usersList: User[];
  getValues: UseFormGetValues<{
    projectId: string;
    userIdsList: never[];
  }>;
  setValue: UseFormSetValue<{
    projectId: string;
    userIdsList: never[];
  }>;
}) => {
  const [filteredUsersList, setFilteredUsersList] = useState<User[] | null>(
    null
  );
  const searchTermUser = useAppSelector(
    (state) => state.gestioneUsersSlice.filters.globalSearch
  );

  const filterListBySearchTerm = useCallback(() => {
    const filteredList = usersList
      ?.filter((item) => {
        return (
          (item.name + " " + item.lastName)
            .toLowerCase()
            .includes(searchTermUser?.toLowerCase() ?? "") ||
          item.email.toLowerCase().includes(searchTermUser?.toLowerCase() ?? "")
        );
      })
      .sort((a: User, b: User) => {
        return getValues("userIdsList").some((item: string) => item === a.id) &&
          !getValues("userIdsList").some((item: string) => item === b.id)
          ? -1
          : 1;
      });

    setFilteredUsersList(filteredList);
  }, [getValues, usersList, searchTermUser]);

  useEffect(() => {
    setFilteredUsersList(usersList);
  }, [usersList]);

  useEffect(() => {
    filterListBySearchTerm();
  }, [searchTermUser, filterListBySearchTerm]);

  const changeCheckboxStatus = (e: any) => {
    if (e.target.id) {
      let userIdsListValue = JSON.parse(
        JSON.stringify(getValues("userIdsList"))
      );
      const findUserIndex = userIdsListValue.findIndex(
        (item: string) => item === e.target.value
      );
      if (findUserIndex === -1) {
        userIdsListValue.push(e.target.value);
      } else {
        userIdsListValue.splice(findUserIndex, 1);
      }
      setValue("userIdsList", userIdsListValue);
      filterListBySearchTerm();
    }
  };

  return (
    <div className="card height-100">
      <div className="flex-container column height-100">
        <div className="margin-bottom-18 margin-top-4 width-100">
          <InputSearchUsersShareModal />
        </div>
        {filteredUsersList ? (
          filteredUsersList?.length ? (
            filteredUsersList?.map((user, index) => {
              return (
                <div
                  key={user.id}
                  className="flex-container align-center menu-item-border-bottom width-100"
                >
                  <Controller
                    name="userIdsList"
                    control={control}
                    render={({ field }) => (
                      <>
                        <Checkbox
                          id={`${field.name}-${index}`}
                          inputId={user.id}
                          {...field}
                          value={user.id}
                          checked={getValues("userIdsList").some(
                            (item: string) => item === user.id
                          )}
                          onChange={changeCheckboxStatus}
                        />

                        <label
                          htmlFor={user.id}
                          className=" flex-container gap-8 padd-14 align-center"
                        >
                          <Avatar
                            label={`${user.name
                              .charAt(0)
                              .toUpperCase()}${user.lastName
                              .charAt(0)
                              .toUpperCase()}`}
                            size="large"
                            shape="square"
                          />{" "}
                          <div className="flex-container column justify-center">
                            <div>
                              <span className="text-base-bold capitalize d-iblock">
                                {user.name}&nbsp;
                              </span>
                              <span className="text-base-bold capitalize d-iblock">
                                {user.lastName}
                              </span>
                            </div>
                            <span className="text-base-regular">
                              {user.email}
                            </span>
                          </div>
                        </label>
                      </>
                    )}
                  />
                </div>
              );
            })
          ) : (
            <div className="flex-container column align-center justify-center height-100">
              <img
                src={elementNotFoundImage}
                alt={labelUserNotFound}
                width="200px"
              />
              <span className="text-base-regular light-grey">
                {labelUserNotFound}
              </span>
            </div>
          )
        ) : (
          <></>
        )}
      </div>
    </div>
  );
};
